import { DateTime } from 'luxon';

/** Matches a valid HH:mm time string (00:00–23:59). */
export const TIME_PATTERN = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;

/**
 * Normalizes a 4-digit time input ('0930') into 'HH:mm' ('09:30').
 * Any other input (already formatted, partial, empty, null) is returned unchanged.
 */
export function normalizeTimeInput(value: string | null | undefined): string | null {
  if (!value) return value ?? null;

  const match = /^(\d{2})(\d{2})$/.exec(value);

  return match ? `${match[1]}:${match[2]}` : value;
}

/** Parses an 'HH:mm' string into its numeric hour/minute parts. */
export function parseTimeParts(time: string): { hour: number; minute: number } {
  return {
    hour: Number.parseInt(time.substring(0, 2)),
    minute: Number.parseInt(time.substring(3, 5)),
  };
}

/** Applies an 'HH:mm' time onto a DateTime, keeping its date. */
export function applyTimeToDate(date: DateTime, time: string): DateTime {
  return date.set(parseTimeParts(time));
}
